import { useAppStore } from '@/providers/AppStoreProvider';

const useFavoritesGameClick = () => {
  const { setFavoriteCasinoGame, removeFavoriteCasinoGame, favoriteCasinoGames, profileUuid } = useAppStore(
    (state) => ({
      setFavoriteCasinoGame: state.setFavoriteCasinoGame,
      removeFavoriteCasinoGame: state.removeFavoriteCasinoGame,
      favoriteCasinoGames: state.favoriteCasinoGames,
      profileUuid: state.profileUuid,
    })
  );

  const handleFavoriteClick = (gameId: string) => {
    if (profileUuid) {
      if ((favoriteCasinoGames[profileUuid] || []).includes(gameId)) {
        removeFavoriteCasinoGame(gameId);
      } else {
        setFavoriteCasinoGame(gameId);
      }
    }
  };

  return {
    handleFavoriteClick,
    favoriteCasinoGameIds: profileUuid ? favoriteCasinoGames[profileUuid] || [] : [],
  };
};

export default useFavoritesGameClick;
